import { __awaiter } from "tslib";
import { get } from 'svelte/store';
import { Service } from './container';
import { Backend } from './backend';
import { Wix } from './wix';
import { Config } from './config';
import { Shopify } from './shopify';
import { Bigcommerce } from './bigcommerce';
import { AppState } from '../etc/stores';
import { Woocommerce } from './woocommerce';
export class StatefulService extends Service {
    constructor() {
        var _a;
        super(...arguments);
        this.config = this.ctx.get(Config);
        this.backend = this.ctx.get(Backend);
        this.provider = (_a = this.config.getSiteSettings().provider) !== null && _a !== void 0 ? _a : 'wix';
    }
    getProviderApi() {
        switch (this.provider) {
            case 'wix':
                return this.ctx.get(Wix);
            case 'shopify':
                return this.ctx.get(Shopify);
            case 'bigcommerce':
                return this.ctx.get(Bigcommerce);
            case 'woocommerce':
                return this.ctx.get(Woocommerce);
        }
        throw new Error(`cannot find provider "${this.provider}"`);
    }
    getSiteAuthState() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.getProviderApi().getAuthState();
        });
    }
    getAppState() {
        return get(AppState);
    }
    getAuthState() {
        return this.getProviderApi().getAuthState();
    }
    isCurrentCartPage() {
        return (this.getProviderApi().isCurrentCartPage &&
            this.getProviderApi().isCurrentCartPage());
    }
    isCurrentRemindCodePage() {
        return (this.getProviderApi().isCurrentRemindCodePage &&
            this.getProviderApi().isCurrentRemindCodePage());
    }
    isSoftLoginEnabled() {
        return (this.getProviderApi().isSoftLoginEnabled &&
            this.getProviderApi().isSoftLoginEnabled());
    }
    applyCoupon(couponCode) {
        this.getProviderApi().applyCoupon &&
            this.getProviderApi().applyCoupon(couponCode);
    }
    getCheckoutInformation() {
        return this.getProviderApi().getCheckoutInformation();
    }
    registerWebsiteEvents() {
        this.getProviderApi().registerWebsiteEvents();
    }
    openLoginModal(data) {
        if (this.canOpenLoginModal()) {
            this.getProviderApi().openLoginModal(data);
        }
    }
    isConnectingAccount() {
        return this.getProviderApi().isConnectingAccount();
    }
    canOpenLoginModal() {
        return typeof this.getProviderApi().openLoginModal === 'function';
    }
    beforeAuthHook() {
        const provider = this.getProviderApi();
        return provider.beforeAuthHook && provider.beforeAuthHook();
    }
    isAuthenticatedOnWebsite() {
        return __awaiter(this, void 0, void 0, function* () {
            const { userId } = yield this.getAuthState();
            return !!userId;
        });
    }
}
